export default __webpack_public_path__ + "static/media/arrow-down.09cd191b.svg";